module.exports = __webpack_public_path__ + "img/page_image_2_5.b7decc58.svg";